export const dailyCompletionList = (
  state = { fabrics: [], styles: [] },
  action
) => {
  if (action.type === 'FETCH_DAILY_COMPLETION_LIST') {
    return action.payload;
  }
  if (action.type === 'CLEAR_DAILY_COMPLETION_LIST') {
    return { fabrics: [], styles: [] };
  }
  return state;
};
